import { Box, Paper, Skeleton, Typography } from "@mui/material";
import Tooltip from "../../../Atoms/Tooltip";

export const InvoiceCard = ({
  title,
  value,
  icon: Icon,
  loading
}) => (
  <Paper
    sx={{
      p: 2,
      height: "100%",
      border: "1px solid #e0e0e0",
      display: "flex",
      alignItems: "center",
      color: "text.secondary",
    }}>
    <Box sx={{ mr: 2, display: "flex", alignItems: "center" }}>
      <Icon style={{ fontSize: "3.5rem" }} />
    </Box>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography variant="subtitle1" fontWeight={500}>
        {title}
      </Typography>

      {loading ? (
        <Skeleton height={30} width="70%" sx={{ mt: 1 }} />
      ) : (
        <Tooltip title={value}>
          <Typography
            variant="h5"
            fontWeight={600}
            noWrap
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {value}
          </Typography>
        </Tooltip>
      )}
    </Box>
  </Paper>
);